import { Component, Input, OnInit } from '@angular/core';
import { UserMessage } from 'src/app/client/repositories/user-message/models/user-message.model';
import { CustomerPortalUser } from 'src/app/client/repositories/user/models/user.model';

@Component({
  selector: 'app-message-container',
  templateUrl: './message-container.component.html',
  styleUrls: ['./message-container.component.scss'],
})
export class MessageContainerComponent implements OnInit {
  @Input() message: UserMessage;
  @Input() user?: CustomerPortalUser;
  @Input() currentUser = true;

  ngOnInit(): void {}
}
